import { render, staticRenderFns } from "./ClientInsights.vue?vue&type=template&id=3559f51d&scoped=true&"
import script from "./ClientInsights.vue?vue&type=script&lang=js&"
export * from "./ClientInsights.vue?vue&type=script&lang=js&"
import style0 from "./ClientInsights.vue?vue&type=style&index=0&id=3559f51d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3559f51d",
  null
  
)

export default component.exports